export const bitcoinTransaction = {
  currency: "Bitcoin",
  symbol: "BTC",
  amount: 0.00018392,
  date: "2024-11-20T08:33:55.000Z",
  hash: "977a5ed2404650ef3fdb95fa65b72b5e9118c524a9720d2b6ee070acedf01ac2",
  position: 1,
  blockId: 57824,
  inputs: [
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000033,
    },
  ],
  outputs: [
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000031,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000032,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000033,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000034,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000035,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000036,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000037,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000038,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000039,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.000004,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000041,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000042,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000043,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000044,
    },
    {
      address: "bc1pgfvkcyfg2hhnnzsk0qv6r2fuv9jlwfy5ykj36ewegglu547wnj9shj8lrh",
      value: 0.0000045,
    },
  ],
  inputValue: 10000,
  outputValue: 10000,
  commission: 0.99,
  commissionB: "4191.363 sat/B",
  commissionVB: "-",
  size: "23,620 Bytes",
  weight: 94480,
  unitOfWeight: "1047.841 sat/WU",
  rbf: false,
  witness: false,
  version: 1,
  blockingTime: 0,
  price: 94518.07,
};
